import React from "react";
import { Link } from "react-router-dom";

/**
 * Quiet closing block used at end of each page.
 * Not a marketing CTA — a gentle "natural next step" invitation.
 */
export default function NaturalNextSteps({ items, note }) {
  return (
    <section className="container-narrow py-24" data-testid="natural-next-steps">
      <div className="max-w-2xl">
        <span className="rule mb-6" />
        <div className="eyebrow mb-3">Natural next steps</div>
        {note && <p className="prose-qr mb-8">{note}</p>}
        <ul className="space-y-4">
          {items.map((it) => (
            <li key={it.to}>
              <Link
                to={it.to}
                className="group flex items-baseline justify-between gap-6 py-3 border-b border-brand-rule/60 hover:border-brand-blue transition-colors"
                data-testid={`next-step-${it.to.replace(/\//g, "") || "home"}`}
              >
                <span className="font-serif text-[22px] sm:text-[26px] text-brand-ink group-hover:text-brand-blue transition-colors">
                  {it.label}
                </span>
                <span className="text-brand-ink/40 group-hover:text-brand-blue transition-transform group-hover:translate-x-1">
                  →
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
